module.exports = __webpack_public_path__ + "Safari Bookshelf-7fe5ca193e713b8573391dd0c1f6feb6.svg";